import { createEntityReducer } from '../../../shared/base';
import { CreatedCategoryEvent, GotAllCategoriesEvent } from './category.events';
import { CategoryState } from './category.state';

export const categoryKey = 'category';
export const initialState: CategoryState = {
  entities: {},
  byQuery: {},
};

export const CategoryReducer = createEntityReducer(
  initialState,
  CreatedCategoryEvent,
  GotAllCategoriesEvent,
);
